<template>
	<div class="elevation-1" style="position: relative;">
    <v-toolbar flat>
      <v-layout row wrap>
        <v-flex xs12>
        	<v-btn flat :outline="filters.input" @click="filters.input = !filters.input" :color="get_color(filters.input)">Input</v-btn>
        	<v-btn flat :outline="filters.output" @click="filters.output = !filters.output" :color="get_color(filters.output)">Output</v-btn>
        	<v-btn flat :outline="filters.headend" @click="filters.headend = !filters.headend" :color="get_color(filters.headend)">Headend</v-btn>
        	<v-btn flat :outline="filters.transcoder" @click="filters.transcoder = !filters.transcoder" :color="get_color(filters.transcoder)">Transcoder</v-btn>
					<v-btn flat :outline="filters.clipper" @click="filters.clipper = !filters.clipper" :color="get_color(filters.Clipper)">Clipper</v-btn>
					<v-btn flat :outline="filters.external_device" @click="filters.external_device = !filters.external_device" :color="get_color(filters.external_device)">External device</v-btn>
					<v-btn flat :outline="filters.mediamtx" @click="filters.mediamtx = !filters.mediamtx" :color="get_color(filters.mediamtx)">MediaMTX</v-btn>
				</v-flex>
				<v-flex xs2>
        </v-flex>
      </v-layout>
    </v-toolbar>

	 <v-data-table :headers="headers" :items="instance_list" hide-actions>
      <template slot="items" slot-scope="props">
        <td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.type }}</td>
        <td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.title }}</td>
        <td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.meta.channel | channel_name }}</td>
        <td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ get_field(props.item, ['system_info', 'ip'], '') }}</td>
        <td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ get_field(props.item, ['system_info', 'version'], '') }}</td>
        <td class="hidden-sm-and-down" :class="{'grey lighten-4': props.item.state == 'archived'}" style="text-align: right; min-width: 190px; max-width: 190px; width: 190px;">
        	<v-btn flat outline color="deep-orange" style="min-width: 50px; max-width: 50px;" small @click.stop="open_gui(props.item)" v-if="is_gui(props.item.type)">GUI</v-btn>
        	<v-btn flat outline color="deep-orange" style="min-width: 50px; max-width: 50px;" small @click.stop="open_ssh(props.item)">SSH</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add"><v-icon>add</v-icon></v-btn>

    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; max-width: 300px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="title_search" ref="search_field" clearable hide-details single-line></v-text-field>
    </v-toolbar>

	</div>
</template>

<script>
import Vue from 'vue'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

export default {
	data () {
		return {
			channel: undefined,
			filters: {
				input: true,
				output: true,
				headend: true,
				transcoder: false,
				clipper: false,
				external_device: false,
				mediamtx: false
			},
			title_search: "",
			headers: [
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Channel', value: 'channel', align: 'left' },
        { text: 'Ip', value: 'ip', align: 'left' },
        { text: 'Version', value: 'version', align: 'left' },
        { text: 'Actions', align: 'right', class: "hidden-sm-and-down"}

			],
		}
	},
	filters: {
		channel_name: function(channel_uuid, a) {
			var ch = app.$store.state.channels_uuid[channel_uuid];
			if (typeof(ch) != "undefined") return ChannelModel.title(ch);
			return channel_uuid;
		}
	},
	computed: {
		instance_list () {
			var tf = this.filters;
			var values = _.values(this.$store.state.instances);
			var search = (this.title_search || "").toLowerCase();

			var ret = _.filter(values, function(instance) {
				var ret = false;
				var it = instance.type;
				if (tf.input == true && it == "input") ret = true;
				if (tf.output == true && it == "output") ret = true;
				if (tf.headend == true && it == "headend") ret =  true;
				if (tf.transcoder == true && it == "transcoder") ret = true;
				if (tf.clipper == true && it == "clipper") ret = true;
				if (tf.external_device == true && it == "external_device") ret = true;
				if (tf.mediamtx == true && it == "mediamtx") ret = true;
				return ret;
			});
			if (search.length > 0 ) {
				ret = _.filter(ret, function(instance) {
					ret = false;
					if (instance.title.toLowerCase().includes(search)) ret = true;
					var ip = _.get(instance, "system_info.ip");
					if (!_.isEmpty(ip)) {
						if (ip.includes(search)) ret = true;
					}
					return ret;
				})
			}
			return ret;

		}
	},
	methods: {
		get_field(data, fields, default_value) {
			return _.get(data, fields, default_value);
		},
		get_color (t) {
			if (t == true) return "";
			return "";
		},
		open_edit (id) {
			this.$router.push("/instances/edit/" + id);
		},
		open_add () {
			this.$router.push("/instances/new");
		},
		is_gui (type) {
			if (type == "headend" || type == "clipper" || type == "external_device") return false;
			return true;
		},
		open_gui (item) {
			window.open(InstanceModel.gui_url(item));
		},
		open_ssh (item) {
			window.location.href = InstanceModel.ssh_url(item);
		}
	},
	mounted () {
		this.$refs.search_field.focus();
	}
}
</script>
